import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const module_files = require.context("./modules", true, /\.js$/);
const modules = module_files.keys().reduce((modules, module_path) => {
  const module_name = module_path.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = module_files(module_path);
  modules[module_name] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [
    createPersistedState({
      paths: ["history"],
    }),
  ],
});
export default store;
